module.exports = __webpack_public_path__ + "static/media/mmIntro.676c0e34.jpg";